import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, vModelText as _vModelText, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22e7366c")

_pushScopeId("data-v-22e7366c")
const _hoisted_1 = { class: "social-post-page" }
const _hoisted_2 = { class: "social-post-page__content" }
const _hoisted_3 = { class: "social-post-page__header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left me-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_6 = { class: "social-post-page__title mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Preparing media uploads… Your post will be ready shortly. ")
const _hoisted_10 = {
  key: 1,
  class: "alert alert-warning mb-4"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Connect your AI 24/7 first before publishing content. ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Complete setup in the ")
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Portal", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" tab.")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_16 = {
  key: 2,
  class: "alert alert-info mb-4"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Connect at least one social account in the ")
const _hoisted_18 = /*#__PURE__*/_createVNode("strong", null, "Social Fan-out", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" tab")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Social Fan-out")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" settings before publishing. ")
const _hoisted_22 = { class: "row g-4" }
const _hoisted_23 = { class: "col-lg-7" }
const _hoisted_24 = { class: "social-post-page__composer card border-0" }
const _hoisted_25 = { class: "card-body p-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label" }, "Post to", -1)
const _hoisted_27 = { class: "d-inline-flex align-items-center gap-2" }
const _hoisted_28 = { class: "text-muted fs-8" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label" }, "Type content", -1)
const _hoisted_30 = { class: "social-post-page__editor" }
const _hoisted_31 = { class: "social-post-page__toolbar" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pen-fancy" }, null, -1)
const _hoisted_33 = { class: "d-flex flex-column gap-2" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fas fa-magic" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "far fa-image" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__tool-btn",
  title: "Add image or video URL"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-link" })
], -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Media URLs", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8" }, "External image and video URLs supported.", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__tool-btn",
  title: "Add link"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-external-link-alt" })
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Link URL", -1)
const _hoisted_41 = { class: "social-post-page__follow-up mt-4" }
const _hoisted_42 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-0" }, "Follow up comment", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "fs-8" }, [
  /*#__PURE__*/_createVNode("strong", null, "Available for"),
  /*#__PURE__*/_createVNode("ul", { class: "mb-0 ps-3 mt-1" }, [
    /*#__PURE__*/_createVNode("li", null, "Facebook Pages"),
    /*#__PURE__*/_createVNode("li", null, "Instagram Business Account"),
    /*#__PURE__*/_createVNode("li", null, "LinkedIn Profiles and Pages")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "mt-2 text-muted" }, "Not supported for Google Business Profile or TikTok.")
], -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__info-btn",
  "aria-label": "Follow up comment help"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle" })
], -1)
const _hoisted_46 = { class: "text-muted fs-8 mt-1" }
const _hoisted_47 = {
  key: 0,
  class: "social-post-page__facebook-options mt-4"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("span", null, "Facebook options", -1)
const _hoisted_49 = { class: "social-post-page__facebook-panel mt-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Post this as", -1)
const _hoisted_51 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_52 = { class: "text-muted fs-8 mt-2" }
const _hoisted_53 = {
  key: 1,
  class: "social-post-page__attachments mt-3"
}
const _hoisted_54 = {
  key: 1,
  class: "social-post-page__attachment-video"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "fas fa-video text-white" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__attachment-label" }, "New", -1)
const _hoisted_58 = {
  key: 1,
  class: "social-post-page__attachment-video"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "fas fa-video text-white" }, null, -1)
const _hoisted_60 = {
  key: 2,
  class: "social-post-page__cascade mt-4"
}
const _hoisted_61 = { class: "form-check" }
const _hoisted_62 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "cascadeToTeam"
}, " Also post to my team's social accounts ", -1)
const _hoisted_63 = {
  key: 0,
  class: "social-post-page__cascade-notes mt-2"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8" }, [
  /*#__PURE__*/_createTextVNode(" Team members receive a "),
  /*#__PURE__*/_createVNode("strong", null, "feed post linking to your original"),
  /*#__PURE__*/_createTextVNode(". Reels, Stories, Instagram, and TikTok are not sent to the team. ")
], -1)
const _hoisted_65 = { class: "form-check mt-2" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "varyCaption"
}, " Use a different caption for each team member ", -1)
const _hoisted_67 = {
  key: 0,
  class: "text-muted fs-8 mt-1"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8 mt-2" }, " Team posts are scheduled after yours, spaced apart. Coordinated engagement farming may result in reduced reach on social platforms. ", -1)
const _hoisted_69 = {
  key: 1,
  class: "text-muted fs-8 mt-1"
}
const _hoisted_70 = { class: "social-post-page__footer" }
const _hoisted_71 = {
  ref: "postActionsRef",
  class: "social-post-page__post-actions"
}
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane me-2" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Post now")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Schedule post")
const _hoisted_76 = { class: "col-lg-5" }
const _hoisted_77 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Date and time", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_ContentMediaLibrary = _resolveComponent("ContentMediaLibrary")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_SocialPostPreview = _resolveComponent("SocialPostPreview")
  const _component_SuggestCaptionDialog = _resolveComponent("SuggestCaptionDialog")
  const _component_SuggestPostImageDialog = _resolveComponent("SuggestPostImageDialog")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-sm btn-light social-post-page__back",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewHistory && _ctx.viewHistory(...args)))
            }, [
              _hoisted_4,
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createVNode("h4", _hoisted_6, _toDisplayString(_ctx.pageTitle), 1),
        _createVNode("button", {
          type: "button",
          class: "btn btn-sm btn-link social-post-page__history",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.viewHistory && _ctx.viewHistory(...args)))
        }, " View history ")
      ]),
      (_ctx.campaignStatus === 'preparing')
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hasGhlLocation)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _hoisted_11,
            (_ctx.embedded)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14
                ], 64))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/settings/ai247-portal",
                  class: "fw-bold"
                }, {
                  default: _withId(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
          ]))
        : (_ctx.connectedAccounts.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _hoisted_17,
              (_ctx.embedded)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_18,
                    _hoisted_19
                  ], 64))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/settings/ai247-portal?tab=social",
                    class: "fw-bold"
                  }, {
                    default: _withId(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  })),
              _hoisted_21
            ]))
          : _createCommentVNode("", true),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_el_select, {
                modelValue: _ctx.selectedAccountKeys,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedAccountKeys = $event)),
                multiple: "",
                filterable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                placeholder: "Select a social account",
                class: "w-100 mb-4",
                disabled: !_ctx.hasGhlLocation || !_ctx.connectedAccounts.length,
                onChange: _ctx.onAccountsChange
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectedAccounts, (account) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: _ctx.accountOptionKey(account),
                      label: _ctx.accountDisplayName(account),
                      value: _ctx.accountOptionKey(account)
                    }, {
                      default: _withId(() => [
                        _createVNode("span", _hoisted_27, [
                          _createVNode("i", {
                            class: _ctx.getPlatformMeta(account.platform).icon,
                            style: { color: _ctx.getPlatformMeta(account.platform).color }
                          }, null, 6),
                          _createVNode("span", null, _toDisplayString(_ctx.accountDisplayName(account)), 1),
                          _createVNode("span", _hoisted_28, "(" + _toDisplayString(_ctx.getPlatformMeta(account.platform).label) + ")", 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange"]),
              _hoisted_29,
              _createVNode("div", _hoisted_30, [
                _withDirectives(_createVNode("textarea", {
                  ref: "captionInput",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.caption = $event)),
                  class: "social-post-page__textarea",
                  placeholder: "Write your post here...",
                  rows: "6"
                }, null, 512), [
                  [_vModelText, _ctx.form.caption]
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 220,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _createVNode("button", {
                        type: "button",
                        class: "social-post-page__tool-btn",
                        title: "Suggest caption",
                        disabled: !_ctx.hasGhlLocation
                      }, [
                        _hoisted_32
                      ], 8, ["disabled"])
                    ]),
                    default: _withId(() => [
                      _createVNode("div", _hoisted_33, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light text-start",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openSuggestCaption('draft')))
                        }, " Write a new caption "),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light text-start",
                          disabled: !_ctx.form.caption.trim(),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSuggestCaption('rewrite')))
                        }, " Rewrite what's in the box ", 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode("button", {
                    type: "button",
                    class: "social-post-page__tool-btn",
                    title: "Suggest post image",
                    disabled: !_ctx.hasGhlLocation,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openSuggestPostImage && _ctx.openSuggestPostImage(...args)))
                  }, [
                    _hoisted_34
                  ], 8, ["disabled"]),
                  _createVNode("input", {
                    ref: "fileInput",
                    type: "file",
                    accept: "image/*,video/*",
                    multiple: "",
                    class: "d-none",
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelected && _ctx.onFilesSelected(...args)))
                  }, null, 544),
                  _createVNode("button", {
                    type: "button",
                    class: "social-post-page__tool-btn",
                    title: "Upload image or video",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.triggerFilePicker && _ctx.triggerFilePicker(...args)))
                  }, [
                    _hoisted_35
                  ]),
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 320,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _hoisted_36
                    ]),
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _hoisted_37,
                        _withDirectives(_createVNode("textarea", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.mediaUrlsText = $event)),
                          class: "form-control form-control-sm mb-2",
                          rows: "4",
                          placeholder: "One URL per line"
                        }, null, 512), [
                          [_vModelText, _ctx.mediaUrlsText]
                        ]),
                        _hoisted_38
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 280,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _hoisted_39
                    ]),
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _hoisted_40,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.linkUrl = $event)),
                          type: "url",
                          class: "form-control form-control-sm",
                          placeholder: "https://..."
                        }, null, 512), [
                          [_vModelText, _ctx.form.linkUrl]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    width: 320
                  }, {
                    content: _withId(() => [
                      _hoisted_44
                    ]),
                    default: _withId(() => [
                      _hoisted_45
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.followUpComment = $event)),
                  class: "social-post-page__textarea social-post-page__textarea--compact",
                  placeholder: "Your first comment...",
                  rows: "3",
                  maxlength: _ctx.maxFollowUpCommentLength
                }, null, 8, ["maxlength"]), [
                  [_vModelText, _ctx.form.followUpComment]
                ]),
                _createVNode("div", _hoisted_46, _toDisplayString(_ctx.followUpCommentLength) + " / " + _toDisplayString(_ctx.maxFollowUpCommentLength) + " characters ", 1)
              ]),
              (_ctx.hasFacebookSelected)
                ? (_openBlock(), _createBlock("div", _hoisted_47, [
                    _createVNode("button", {
                      type: "button",
                      class: "social-post-page__section-toggle",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.facebookOptionsOpen = !_ctx.facebookOptionsOpen))
                    }, [
                      _hoisted_48,
                      _createVNode("i", {
                        class: _ctx.facebookOptionsOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                      }, null, 2)
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode("div", _hoisted_51, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.facebookPostTypeOptions, (option) => {
                          return (_openBlock(), _createBlock("label", {
                            key: option.value,
                            class: "social-post-page__radio-option"
                          }, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.facebookPostType = $event)),
                              type: "radio",
                              name: "facebookPostType",
                              value: option.value
                            }, null, 8, ["value"]), [
                              [_vModelRadio, _ctx.form.facebookPostType]
                            ]),
                            _createVNode("span", null, _toDisplayString(option.label), 1)
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_52, _toDisplayString(_ctx.facebookPostTypeHelp), 1)
                    ], 512), [
                      [_vShow, _ctx.facebookOptionsOpen]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pendingFiles.length || _ctx.attachedPreviewUrls.length)
                ? (_openBlock(), _createBlock("div", _hoisted_53, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pendingFiles, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: `pending-${index}`,
                        class: "social-post-page__attachment"
                      }, [
                        (item.previewUrl && item.isImage)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: item.previewUrl,
                              alt: ""
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("div", _hoisted_54, [
                              _hoisted_55
                            ])),
                        _createVNode("button", {
                          type: "button",
                          class: "social-post-page__attachment-remove",
                          onClick: ($event: any) => (_ctx.removePendingFile(index))
                        }, [
                          _hoisted_56
                        ], 8, ["onClick"]),
                        _hoisted_57
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachedPreviewUrls, (url) => {
                      return (_openBlock(), _createBlock("div", {
                        key: url,
                        class: "social-post-page__attachment"
                      }, [
                        (_ctx.isPreviewImage(url))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: url,
                              alt: ""
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("div", _hoisted_58, [
                              _hoisted_59
                            ]))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ContentMediaLibrary, {
                ref: "mediaLibrary",
                "selected-ids": _ctx.attachedMediaIds,
                "onUpdate:selected-ids": _cache[15] || (_cache[15] = ($event: any) => (_ctx.attachedMediaIds = $event)),
                onRefresh: _ctx.onMediaLibraryRefresh
              }, null, 8, ["selected-ids", "onRefresh"]),
              (_ctx.isTeamLeader)
                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                    _createVNode("div", _hoisted_61, [
                      _withDirectives(_createVNode("input", {
                        id: "cascadeToTeam",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.cascadeToTeam = $event)),
                        class: "form-check-input",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.cascadeToTeam]
                      ]),
                      _hoisted_62
                    ]),
                    (_ctx.form.cascadeToTeam)
                      ? (_openBlock(), _createBlock("div", _hoisted_63, [
                          _hoisted_64,
                          _createVNode("div", _hoisted_65, [
                            _withDirectives(_createVNode("input", {
                              id: "varyCaption",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.varyCaption = $event)),
                              class: "form-check-input",
                              type: "checkbox"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.form.varyCaption]
                            ]),
                            _hoisted_66
                          ]),
                          (_ctx.form.varyCaption)
                            ? (_openBlock(), _createBlock("div", _hoisted_67, " Uses AI tokens (charged to you, once per team member). "))
                            : _createCommentVNode("", true),
                          _hoisted_68
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_69, " Team members must have opted in via Social Fan-out settings. "))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-light",
                disabled: _ctx.footerDisabled,
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args)))
              }, _toDisplayString(_ctx.saving ? "Saving..." : "Save for later"), 9, ["disabled"]),
              _createVNode("div", _hoisted_71, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary social-post-page__post-btn",
                  disabled: _ctx.footerDisabled,
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.submitPostNow && _ctx.submitPostNow(...args)))
                }, [
                  _hoisted_72,
                  _createTextVNode(" " + _toDisplayString(_ctx.publishing ? "Posting..." : _ctx.postButtonLabel), 1)
                ], 8, ["disabled"]),
                _createVNode(_component_el_dropdown, {
                  trigger: "click",
                  onCommand: _ctx.handlePostMenu
                }, {
                  dropdown: _withId(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_dropdown_item, { command: "now" }, {
                          default: _withId(() => [
                            _hoisted_74
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "schedule" }, {
                          default: _withId(() => [
                            _hoisted_75
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withId(() => [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-primary social-post-page__post-menu",
                      disabled: _ctx.footerDisabled
                    }, [
                      _hoisted_73
                    ], 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["onCommand"])
              ], 512)
            ])
          ]),
          (_ctx.lastResult)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["alert mt-4 mb-0", _ctx.lastResult.status === 'rejected' ? 'alert-danger' : 'alert-info']
              }, [
                (_ctx.lastResult.status === 'preparing')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " is preparing media uploads. ", 1)
                    ], 64))
                  : (_ctx.lastResult.status === 'draft')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Draft saved as campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + ". ", 1)
                      ], 64))
                    : (_ctx.lastResult.status === 'rejected')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " was blocked by AI review: " + _toDisplayString(_ctx.lastResult.moderationSummary || 'Post violates company rules.'), 1)
                        ], 64))
                      : (_ctx.lastResult.status === 'pending_review')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " is under AI review before team fan-out. ", 1)
                          ], 64))
                        : (_ctx.lastResult.status === 'awaiting_original')
                          ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " — your post is live. Team link posts will be scheduled after the original is confirmed. ", 1)
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                              _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " — posted " + _toDisplayString(_ctx.lastResult.postedCount) + ", skipped " + _toDisplayString(_ctx.lastResult.skippedCount) + ", failed " + _toDisplayString(_ctx.lastResult.failedCount), 1)
                            ], 64))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_76, [
          _createVNode(_component_SocialPostPreview, {
            "selected-accounts": _ctx.selectedAccounts,
            caption: _ctx.form.caption,
            "media-urls": _ctx.previewMediaUrls,
            "link-url": _ctx.form.linkUrl,
            "follow-up-comment": _ctx.form.followUpComment,
            "facebook-post-type": _ctx.form.facebookPostType
          }, null, 8, ["selected-accounts", "caption", "media-urls", "link-url", "follow-up-comment", "facebook-post-type"])
        ])
      ]),
      _createVNode(_component_SuggestCaptionDialog, {
        modelValue: _ctx.suggestCaptionVisible,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.suggestCaptionVisible = $event)),
        mode: _ctx.suggestCaptionMode,
        platforms: _ctx.form.platforms,
        "existing-caption": _ctx.form.caption,
        onSelect: _ctx.applySuggestedCaption
      }, null, 8, ["modelValue", "mode", "platforms", "existing-caption", "onSelect"]),
      _createVNode(_component_SuggestPostImageDialog, {
        modelValue: _ctx.suggestPostImageVisible,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.suggestPostImageVisible = $event)),
        platforms: _ctx.form.platforms,
        "initial-prompt": _ctx.form.caption,
        onSelect: _ctx.applySuggestedImage
      }, null, 8, ["modelValue", "platforms", "initial-prompt", "onSelect"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.scheduleDialogVisible,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.scheduleDialogVisible = $event)),
        title: "Schedule post",
        width: "360px"
      }, {
        footer: _withId(() => [
          _createVNode("button", {
            type: "button",
            class: "btn btn-light",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.scheduleDialogVisible = false))
          }, " Cancel "),
          _createVNode("button", {
            type: "button",
            class: "btn btn-primary ms-2",
            disabled: !_ctx.form.scheduledAt || _ctx.publishing,
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.submitScheduledPost && _ctx.submitScheduledPost(...args)))
          }, " Schedule ", 8, ["disabled"])
        ]),
        default: _withId(() => [
          _hoisted_77,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.scheduledAt = $event)),
            type: "datetime-local",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.scheduledAt]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
})